import { ArpMedia, ArpMediaSubType, ArpMediaType, ORDER } from '@arpeggi/shared'
import { useEffect, useState } from 'react'
import { useSearch } from '../../../__legacy__/components/platform/new-explore/hooks/useSearch'

type OrderBy = keyof Omit<ArpMedia, 'metadata' | 'subComponents' | 'user'> | 'title'

export type TypeSubtype = {
  types: ArpMediaType[]
  subTypes: ArpMediaSubType[]
}

export interface ArpMediaFilters {
  search?: string
  typesAndSubTypes: TypeSubtype[]
  key: number
  tag?: string[]
  orderBy: OrderBy
  order: ORDER
  genre?: string[]
  excludeIds?: number[]
  subComponentId?: number[]
  walletAddress?: string
  featured?: boolean
  isBlocklist?: boolean
  remix?: boolean
  samplePackId?: number
}

export const TYPES_AND_SUBTYPES = {
  CLIPS: {
    types: [ArpMediaType.STEM],
    subTypes: [ArpMediaSubType.CLIP]
  } as TypeSubtype,
  MIDI: {
    types: [ArpMediaType.STEM],
    subTypes: [ArpMediaSubType.MIDI_INSTRUMENT, ArpMediaSubType.MIDI_DRUM]
  } as TypeSubtype,
  ONE_SHOT: {
    types: [ArpMediaType.SAMPLE],
    subTypes: [null]
  } as TypeSubtype,
  DEFAULT_SOUNDS: {
    types: [ArpMediaType.STEM, ArpMediaType.SAMPLE],
    subTypes: []
  } as TypeSubtype,
  DEFAULT_SONGS: {
    types: [ArpMediaType.SONG],
    subTypes: []
  } as TypeSubtype
}

export const DEFAULT_SOUNDS_INSTRUMENTS: string[] = []
export const DEFAULT_SOUNDS_ORDER_BY: OrderBy = 'favoriteCount'
export const DEFAULT_SOUNDS_ORDER: ORDER = 'desc'
export const DEFAULT_SOUNDS_KEY: number | undefined = undefined
export const DEFAULT_SOUNDS_WALLET_ADDRESS: string | undefined = undefined
export const DEFAULT_SOUNDS_TYPES = [TYPES_AND_SUBTYPES.DEFAULT_SOUNDS]

export const DEFAULT_SOUNDS_FILTERS: ArpMediaFilters = {
  key: DEFAULT_SOUNDS_KEY,
  typesAndSubTypes: DEFAULT_SOUNDS_TYPES,
  tag: DEFAULT_SOUNDS_INSTRUMENTS,
  orderBy: DEFAULT_SOUNDS_ORDER_BY,
  order: DEFAULT_SOUNDS_ORDER,
  walletAddress: DEFAULT_SOUNDS_WALLET_ADDRESS
}

export const DEFAULT_SONGS_TYPES = [TYPES_AND_SUBTYPES.DEFAULT_SONGS]
export const DEFAULT_SONGS_GENRES: string[] = []
export const DEFAULT_SONGS_ORDER_BY: OrderBy = 'mintedAt'
export const DEFAULT_SONGS_ORDER: ORDER = 'desc'
export const DEFAULT_SONGS_KEY: number | undefined = undefined
export const DEFAULT_SONGS_WALLET_ADDRESS: string | undefined = undefined
export const DEFAULT_SONGS_FEATURED_MEDIA: boolean | undefined = undefined

export const DEFAULT_SONGS_FILTERS: ArpMediaFilters = {
  key: DEFAULT_SONGS_KEY,
  typesAndSubTypes: DEFAULT_SONGS_TYPES,
  genre: DEFAULT_SONGS_GENRES,
  orderBy: DEFAULT_SONGS_ORDER_BY,
  order: DEFAULT_SONGS_ORDER,
  walletAddress: DEFAULT_SONGS_WALLET_ADDRESS,
  featured: DEFAULT_SONGS_FEATURED_MEDIA
}

export const useFilters = (defaultFilters: ArpMediaFilters) => {
  const [filters, setFilters] = useState<ArpMediaFilters>(defaultFilters)
  const [search] = useSearch()
  useEffect(() => {
    updateFilters({ search })
  }, [search])
  const updateFilters = (filter: Partial<ArpMediaFilters>) => setFilters({ ...filters, ...filter })
  return { filters, updateFilters }
}
